import CreateTreatmentSchemaForm from './components/forms/CreateTreatmentSchemaForm'
import { TreatmentTable } from './components/treatment-table/TreatmentTable'

const TreatmentPage = () => {
	return <TreatmentTable headerAction={<CreateTreatmentSchemaForm />} />
}

export default TreatmentPage
